import { render, staticRenderFns } from "./footers.vue?vue&type=template&id=fd7a005c&scoped=true"
import script from "./footers.vue?vue&type=script&lang=js"
export * from "./footers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7a005c",
  null
  
)

export default component.exports